import { render, staticRenderFns } from "./CreateTender.vue?vue&type=template&id=cd0f66d0&"
import script from "./CreateTender.vue?vue&type=script&lang=ts&"
export * from "./CreateTender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports